import { InsurerWithSociety } from "@dune/types";
import { Button } from "@dune/ui";
import type { ColumnDef } from "@tanstack/react-table";
import { Pencil, Trash2 } from "lucide-react";
import { TableCellWithTooltip } from "../../component/shared/TableCellWithTooltip";

interface GetInsurerColumnsProps {
	onDelete: (id: number) => void;
	onEdit: (insurer: InsurerWithSociety) => void;
}

export const getInsurerColumns = ({
	onDelete,
	onEdit,
}: GetInsurerColumnsProps): ColumnDef<InsurerWithSociety>[] => [
	{
		accessorKey: "society.denomination",
		header: "Dénomination",
		cell: ({ row }) => (
			<TableCellWithTooltip
				tooltipContent={row.original.society.denomination}
				className="max-w-[500px] font-medium"
			>
				{row.original.society.denomination}
			</TableCellWithTooltip>
		),
	},
	{
		accessorKey: "society.siren",
		header: "SIREN",
		cell: ({ row }) => <div>{row.original.society.siren}</div>,
	},
	{
		accessorKey: "capital",
		header: "Capital",
		cell: ({ row }) => (
			<div>
				{row.original.capital
					? `${row.original.capital.toLocaleString("fr-FR")} €`
					: "-"}
			</div>
		),
	},
	{
		accessorKey: "registrationNumber",
		header: "N° d'inscription",
		cell: ({ row }) => <div>{row.original.registrationNumber || "-"}</div>,
	},
	{
		accessorKey: "society.headOfficeAddress",
		header: "Adresse",
		cell: ({ row }) => {
			const address = row.original.society.headOfficeAddress;
			if (!address) return <div>-</div>;
			return (
				<div className="text-sm">
					{address.streetNumber} {address.streetName}
					<br />
					{address.postalCode} {address.city}
				</div>
			);
		},
	},
	{
		id: "actions",
		header: "Actions",
		cell: ({ row }) => (
			<div className="flex gap-2">
				<Button
					variant="ghost"
					size="sm"
					onClick={() => onEdit(row.original)}
					className="text-blue-600 hover:text-blue-700 hover:bg-blue-50"
				>
					<Pencil className="h-4 w-4" />
				</Button>
				<Button
					variant="ghost"
					size="sm"
					onClick={() => onDelete(row.original.id)}
					className="text-red-600 hover:text-red-700 hover:bg-red-50"
				>
					<Trash2 className="h-4 w-4" />
				</Button>
			</div>
		),
	},
];
